import { render, staticRenderFns } from "./LicenseInfoTalentfind.vue?vue&type=template&id=7ec71f56&scoped=true"
import script from "./LicenseInfoTalentfind.vue?vue&type=script&lang=js"
export * from "./LicenseInfoTalentfind.vue?vue&type=script&lang=js"
import style0 from "./LicenseInfoTalentfind.vue?vue&type=style&index=0&id=7ec71f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec71f56",
  null
  
)

export default component.exports